import moment, { Moment } from 'moment-timezone';

interface CalendarProps {
  month: number;
  year: number;
}

export class Calendar {
  month: number;
  year: number;
  calendar: Array<Array<Moment | null>>;

  constructor(props: CalendarProps) {
    this.month = props.month;
    this.year = props.year;
    this.calendar = this.getCalendar();
  }

  getMonth() {
    return this.month;
  }

  getYear() {
    return this.year;
  }

  setMonth(month: number) {
    this.month = month;

    if (this.month < 1) {
      throw new Error('Month cannot be less than 1');
    }

    if (this.month > 12) {
      throw new Error('Month cannot be greater than 12');
    }
  }

  setYear(year: number) {
    this.year = year;
  }

  getDaysInMonth() {
    return moment(new Date(this.year, this.month - 1)).daysInMonth();
  }

  getFirstDayOfMonth() {
    return moment(new Date(this.year, this.month - 1, 1)).day();
  }

  getCalendar() {
    const daysInMonth = this.getDaysInMonth();
    const firstDayOfMonth = this.getFirstDayOfMonth();
    const calendar = [];

    let day = 1;

    while (day <= daysInMonth) {
      const week = [];

      for (let i = 0; i < 7; i++) {
        if (day <= daysInMonth && (i >= firstDayOfMonth || day > 1)) {
          week.push(moment(new Date(this.year, this.month - 1, day++)));
        } else {
          week.push(null);
        }
      }

      calendar.push(week);
    }

    return calendar;
  }

  getPreviousCalendar() {
    const previousMonth = this.month - 1;
    const previousYear = this.year;

    if (previousMonth < 1) {
      this.setMonth(12);
      this.setYear(previousYear - 1);
    } else {
      this.setMonth(previousMonth);
    }

    return this.getCalendar();
  }

  getNextCalendar() {
    const nextMonth = this.month + 1;
    const nextYear = this.year;

    if (nextMonth > 12) {
      this.setMonth(1);
      this.setYear(nextYear + 1);
    } else {
      this.setMonth(nextMonth);
    }

    return this.getCalendar();
  }
}
